export default __webpack_public_path__ + "static/media/threeMiddleRight.2a9198ae.png";